import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
@Component({
  selector: 'app-feed-layout',
  templateUrl: './feed-layout.component.html',
  styleUrls: ['./feed-layout.component.css']
})

export class FeedLayoutComponent implements OnInit, AfterViewInit {
  allPosts : any;
  constructor(private elementRef: ElementRef) {}
  
  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
    this.elementRef.nativeElement.ownerDocument.body.style.color = 'black';
    //console.log(this.elementRef.nativeElement.ownerDocument);
  }
  
  public ngOnInit(){
    //console.log ("initializing feed layout");
  }
}